package core.validation

import core.validation.field.Field

/**
 * Represents a form that can be validated.
 */
abstract class Form {
    /**
     * The list of fields to validate.
     */
    abstract val fields: List<Field>

    /**
     * Whether the form is valid.
     */
    val isValid get() = fields.none { it.state.isError }

    /**
     * Validates the form.
     *
     * The form is considered valid if all the fields are valid.
     *
     * The [isValid] property is updated to `true` if the form is valid, and `false` otherwise.
     *
     * @return `true` if the form is valid, `false` otherwise.
     */
    fun validate(): Boolean {
        val isValid = fields.map { it.validate() }.all { it }

        return isValid
    }

    /**
     * Resets the form.
     */
    fun reset() {
        fields.forEach { it.reset() }
    }
}
